import { ID, IDRecord, UserSession } from '../types';
import { Set } from 'immutable';
import Collection from './Collection';
import Contact from './Contact';

export default class SearchResults extends Collection<IDRecord> {
  hitsPerPage: number;
  page: number;
  user: UserSession;
  deletedIDs: Set<ID>;

  constructor(props: any = {}) {
    super(props);

    // instead of limit/offset, search endpoint uses hitsPerPage/page for pagination
    this.hitsPerPage = props.hitsPerPage || 100;
    this.page = props.page || 1;
    // using this for .canLoadMore method on Collection
    this.persistedItemsOnServer =
      typeof props.found == 'number' ? props.found : props.persistedItemsOnServer || -1;
    this.user = props.user || { contact_id: '' };
    this.offset = this.items.size - 1;
    this.deletedIDs = props.deletedIDs || Set();
  }

  get userID() {
    return String(this.user.contact_id || '');
  }

  get totalResults(): number {
    const unfilteredItemCount = this.items.size;
    const filteredItemCount = this.filteredItems.size;
    const totalResults = this.persistedItemsOnServer - (unfilteredItemCount - filteredItemCount);
    return totalResults > 0 ? totalResults : 0;
  }

  get filteredItems() {
    const withoutUsersOwnID =
      this.userID != '' ? this.items.filter(({ id }) => id != this.userID) : this.items;
    return withoutUsersOwnID.filter((_, id) => !this.deletedIDs.has(id));
  }

  asContactArray(getContact: (id: ID) => Contact): Contact[] {
    return this.filteredItems
      .map(({ id }) => getContact(id))
      .filter((x) => !!x)
      .valueSeq()
      .toArray();
  }
}
